/** Shared preset list + custom cap for event listing pages (WAF, FW, Bot, RL, API Security Events). */
export const EVENT_LISTING_PRESET_PERIODS = ["30m", "60m", "3h", "6h", "24h", "3d", "7d"];
export const EVENT_LISTING_MAX_CUSTOM_DAYS = 7;

export { getDefaultWafCustomDateRange as getDefaultEventListingCustomDateRange } from "./wafEventListUtils";
